import React, {MouseEventHandler} from 'react';
import {BoxProps} from '@material-ui/core/Box';

import {BlueButton} from '../../blue-button/blue-button.styled';
import {StackProps} from '../../layout/layout.styled';
import {FormControl} from '../form-control/form-control.styles';

export type ButtonFormControlProps = {
    labelText?: string
    'data-testid'?: string
    labelProps?: BoxProps
    buttonLabelText?: string
    stackProps?: StackProps
    buttonProps?: BoxProps
    onClick?: MouseEventHandler
    isLoading?: boolean
}

export const ButtonFormControl = ({
    onClick,
    'data-testid': dataTestId = 'Button',
    isLoading = false,
    labelText = '_',
    labelProps,
    stackProps,
    buttonProps,
    buttonLabelText
}: ButtonFormControlProps) => {
    return (
        <FormControl
            data-testid={dataTestId}
            labelText={labelText}
            labelProps={{
                ...labelProps,
                style: {
                    ...labelProps?.style,
                    // hide the label so that the button fits in the layout
                    opacity: labelText === '_' ? 0 : 1
                }
            }}
            {...stackProps}
        >
            <BlueButton
                m={'10px'}
                onClick={onClick}
                isLoading={isLoading}
                {...buttonProps}
            >
                {buttonLabelText}
            </BlueButton>
        </FormControl>
    );
};
